(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/payfooter.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/payfooter.js');

'use strict';

const {
  BETSLIP_COMPLETE
} = svs.numbergames.game.analytics_events;
svs.lotto.components.play.views.Payfooter = Marionette.View.extend({
  viewOptions: ['analyticsEvents'],
  analyticsEvents: [BETSLIP_COMPLETE],
  className: 'numbergames-payfooter',
  regions: {
    payfooterRegion: '#payfooterRegion'
  },
  template() {
    return '<div id="payfooterRegion"></div>';
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    const PayfooterView = svs.core.config.data.svsconfig.isSelfService ? svs.numbergames.game.views.PayFooterSelfservice : svs.numbergames.game.views.PayFooterOnline;
    this.showChildView('payfooterRegion', new PayfooterView({
      model: this.model,
      analyticsEvents: this.analyticsEvents
    }));
  }
});

 })(window);